<template>
  <section>
    <v-skeleton-loader v-if="loading" type="article" />
    <template v-else>
      <v-slide-group>
        <v-slide-item v-for="item in forecasts" :key="item.number">
          <v-card
              class="tw-m-2"
              height="200"
              width="100"
              @click="detailHandle(item)"
          >
            <v-img :src="item.icon" aspect-ratio="1" />
            <v-container>
              <p class="subtitle-2 tw-mb-1" style="height: 44px">{{ item.name }}</p>
              <p>{{ item.temperature + ' ' + item.temperatureUnit }}</p>
            </v-container>
          </v-card>
        </v-slide-item>
      </v-slide-group>
      <v-dialog v-model="show.detail" max-width="600">
        <v-card>
          <v-card-title>Detail Weather</v-card-title>
          <v-card-text>
            {{ active.detailedForecast }}
          </v-card-text>
          <v-card-text>
            <c-data-list :value="prepareForecastData(active)" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </section>
</template>

<script>
export default {
  name: 'TheStationDetailSummaryWeather',
  props: {
    station: {
      type: Object
    }
  },
  async created () {
    const res = await this.$api.weather.find({
      latitude: this.station.latitude,
      longitude: this.station.longitude
    })
    this.loading = false
    this.forecasts = res.properties.periods
    console.log(this.forecasts)
  },
  data () {
    return {
      loading: true,
      forecasts: [],
      active: {},
      show: {
        detail: false
      }
    }
  },
  methods: {
    prepareForecastData (forecast) {
      return [
        {
          label: 'Temperature',
          value: forecast.temperature + ' ' + forecast.temperatureUnit
        },
        {
          label: 'Wind Speed',
          value: forecast.windSpeed
        },
        {
          label: 'Wind Direction',
          value: forecast.windDirection
        },
        {
          label: 'Short Forecast',
          value: forecast.shortForecast
        }
      ]
    },
    detailHandle (item) {
      this.active = item
      this.show.detail = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
